import React from 'react';
import { injectIntl } from 'react-intl';

interface IProps{
    meta:any;
    intl:any;
    min?:number;
    max?:number;
}
const ReduxFormErrorHandler:React.FC<IProps> = props => {
    const _error = props.meta.error
    ? props.intl.formatMessage({ id: props.meta.error })
    : props.meta.error;
    const replaceString = (error:string) => {
        if(props.min && error)
            error = error.replace('{min}', props.min.toString());
        if(props.max && error)
            error = error.replace('{max}', props.max.toString());
        return error;
    }
    return (
    <React.Fragment>
      {props.meta.touched &&
        ((props.meta.error && <span className="text-danger errorMessage">{replaceString(_error)}</span>) ||
          (props.meta.warning && <span className="text-danger">{props.meta.warning}</span>))}
    </React.Fragment>
  );
};

export default injectIntl(ReduxFormErrorHandler);
